import { Jacket } from "entities/UIModel";
import { getJacketTabTitle } from "pages/file/utils/products/jacket";
import React from "react";

type Props = {
  collateralMortgages: Array<{ jacket: Jacket; index: number; }>;
};

// A pending Collateral Mortgage has not been issued yet and so has no policy number —
// name it by its jacket position instead, which is how the user finds it on screen.
const getIdentifier = ({ jacket, index }: { jacket: Jacket; index: number; }) =>
  jacket.productReferenceID || getJacketTabTitle(index);

// The body copy of the dialog shown when a Primary Loan Policy still has Collateral
// Mortgages attached to it. The heading is supplied by the dialog itself.
const CollateralMortgageVoidBlockedMessage = ({ collateralMortgages }: Props) => {
  const isPlural = collateralMortgages.length > 1;
  const noun = isPlural ? "collateral mortgages" : "collateral mortgage";
  const identifiers = collateralMortgages.map(getIdentifier).join(", ");

  return (
    <>
      {`It is associated with ${isPlural ? "" : "a "}${noun}. Please void the ${noun} (${identifiers}) to proceed.`}
    </>
  );
};

export default CollateralMortgageVoidBlockedMessage;
